import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { NoResults } from '@/components'
import { useMobile } from '@/hooks'
import { MemberDetail } from '@/types/User'
import { MobileReservationCard } from '@/views/Reservation/Reservations/MobileReservationCard'

import { MemberReservationListColumns } from './MemberReservations.data'

export const MemberReservations = ({ member }: { member: MemberDetail }) => {
  const { isTablet } = useMobile()

  const reservations = member.reservations || []

  const columns = useMemo(() => {
    return MemberReservationListColumns
  }, [])

  return (
    <div className="flex w-full flex-col py-4">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className=" text-header-lg leading-120">Reservations</h2>
      </div>
      {isTablet ? (
        <>
          {(reservations.length > 0 &&
            reservations.map((reservation, index) => (
              <MobileReservationCard
                header={`Reservation ID: ${reservation.id}`}
                key={index}
                reservation={reservation}
              />
            ))) || <NoResults />}
        </>
      ) : (
        <Table columns={columns as any} data={reservations} />
      )}
    </div>
  )
}
